import * as qiniu from 'qiniu-js'
import { POST, URLS } from '../utils'

import store from '../store'
import { types as TipTypes } from '../store/modules/tip'


/**
 * 获取七牛 token
 * @param {*} file 
 * @param {*} callback 
 * @param {*} progress 
 * @param {*} subscriptionCB 
 */
const GET_QINIU_TOKEN = (filename, callback, is_use_filename) => {
  let dic = {filename: filename}
  if(is_use_filename){
   dic["filekey"] = filename
  }
  POST(URLS.qiniu_token, dic).then(response => {
    let key = response.key
    let token = response.token
    if(callback){
      callback(key, token)
    }
  })
}


/**
 * 上传单个资源(已有七牛token)
 * 完整的 key: bcgame_face2face/8528/bf5ff13851ef8296ed040d8b70b5041b_q.obj
 * 这种同名 key 一般长这样: bcgame_face2face/8528/bf5ff13851ef8296ed040d8b70b5041b_q
 * @param {*} file [ blob 对象 ]
 * @param {*} callback [ 上传成功 或 上传失败的回调 ]
 * @param {*} progress [ 上传进度 ]
 */
const UPLOAD_SINGLE_IMAGE_WITH_TOKEN = (file, callback, progress, subscriptionCB, is_use_filename) => {
  // 将七牛 key 的格式改成跟文件格式一样(为了同时上传多个同名文件但后缀不一样)
  GET_QINIU_TOKEN(file.name, (key, token)=>{
    upload_file(file, key, token, callback, progress, subscriptionCB, is_use_filename)
  }, is_use_filename);
}
const upload_file = (file, qiniu_key, qiniu_token, callback, progress, subscriptionCB, is_use_filename) => {
  // 上传配置, file:上传对象 blob, key:资源名称, token:上传验证身份(后端获取)
  var observable = qiniu.upload(
    file,
    qiniu_key,
    qiniu_token,
    {
      // 文件原文件名
      fname: file.name,

      // 用来放置自定义变量
      params: {},

      // 用来限制上传文件类型，为 null 表示不对类型限制；限制类型放到数组里：["image/png", "image/jpeg", "image/gif"]
      mimeType: null
    },
    {
      // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false
      // useCdnDomain: true,
      // 根据具体提示修改上传地区，当为 null 或 undefine 时，自动分析上传域名区域
      // region: qiniu.region.z2
    }
  )

  // 上传开始
  var subscription = observable.subscribe({
    next: result => {
      // 主要用来展示进度
      // console.log('上传进度(1):', result)
      if (progress) {
        progress(result.total.percent)
      }
    },
    error: errResult => {
      // 失败报错信息
      console.log('上传失败(2):', errResult)
      let msg = ""
      if(errResult.message.includes("exceed FsizeLimit")){
        msg = "文件过大"
      }
      store.commit(TipTypes.SHOW, {
        message: msg,
        submitCB: () => {
          store.commit(TipTypes.HIDE)
        }
      })
      if (callback) {
        callback('')
      }
    },
    complete: result => {
      console.log(result);
      // 接收成功后返回的信息
      let url = result.url
      if(is_use_filename && result.default_url){
        url = result.default_url
      }
      console.log('上传成功(3):', url)
      if (url && callback) {
        callback(url)
      }
    }
  })

  // 将上传对象本身返回，便于调用者可以随时取消上传
  if (subscriptionCB) {
    subscriptionCB(subscription)
  }
}

/**
 * 上传多个资源,多个资源的名字一样，后缀不一样的(已有七牛token)
 * 完整的 key: bcgame_face2face/8528/bf5ff13851ef8296ed040d8b70b5041b_q.obj
 * 这种同名 key 一般长这样: bcgame_face2face/8528/bf5ff13851ef8296ed040d8b70b5041b_q
 * @param {*} files [ 多个 blob 对象组 ]
 * @param {*} callback [ 全部资源上传处理完毕，并返回结果 ]
 * @param {*} progressCB [ 进度条 ]
 */
const UPLOAD_MANY_IMAGE_WITH_TOKEN = UPLOAD_MANY_IMAGE


/**
 * 上传单张图片
 * @param {*} file [ blob 对象 ]
 * @param {*} callback [ 上传成功 或 上传失败的回调 ]
 * @param {*} progress [ 上传进度 ]
 */
const UPLOAD_SINGLE_IMAGE = UPLOAD_SINGLE_IMAGE_WITH_TOKEN

/**
 * 上传多张图片
 * @param {*} files [ 多个 blob 对象组 ]
 * @param {*} callback [ 全部资源上传处理完毕，并返回结果 ]
 * @param {*} progressCB [ 进度条 ]
 */
const UPLOAD_MANY_IMAGE = (files, callback, progressCB, subscriptionCB, is_use_filename) => {
  var index = 0
  var remoteUrls = []

  const Single_Upload_Progress = progress => {
    console.log('第', index, '张图片的进度:', progress)
    // 改变图片的进度值
    if (progressCB) {
      progressCB(progress, index)
    }
  }

  const Single_Upload_Success = url => {
    if (!url) {
      console.log('上传失败(Single_Upload_Success)')
      // 改变图片的进度值
      if (progressCB) {
        progressCB(-1, index)
      }
      index++
    } else {
      console.log('上传成功(Single_Upload_Success):', url)
      remoteUrls.push({ originUrl: files[index]['localUrl'], remoteUrl: url })
      index++
    }
    if (index >= files.length) {
      // 图片已全部上传完毕
      if (callback) {
        callback(remoteUrls)
      }
    } else {
      console.log('第', index, '张图片开始上传------')
      UPLOAD_SINGLE_IMAGE(files[index]['file'], Single_Upload_Success, Single_Upload_Progress, subscriptionCB, is_use_filename)
    }
  }

  console.log('第', index, '张图片开始上传-----')
  UPLOAD_SINGLE_IMAGE(files[index]['file'], Single_Upload_Success, Single_Upload_Progress, subscriptionCB, is_use_filename)
}

export { 
  UPLOAD_SINGLE_IMAGE, 
  UPLOAD_MANY_IMAGE, 
  GET_QINIU_TOKEN, 
  UPLOAD_MANY_IMAGE_WITH_TOKEN, 
  UPLOAD_SINGLE_IMAGE_WITH_TOKEN 
}
